'use client'

import type { FC, PropsWithChildren } from 'react'
import { useUser } from '@sylveraio/data'
import { useIntercom } from '@sylveraio/react-utils'

export const IntercomProvider: FC<PropsWithChildren> = ({ children }) => {
  const { data: user } = useUser()

  useIntercom(user ?? undefined)

  return children
}
